<div class="w-full mt-3 mb-1">
  <span
    class="bg-red-2 py-1 px-4 rounded-[30px] text-white font-roboto-400 text-15 max-sm:text-11 max-sm:px-2"
  >
    {{ handleDate() }}
  </span>
</div>
